import 'jquery';
import * as utils from './utils';
import { Components } from './components';
import '@sop/unify-bootstrap';

export class Modal {
    constructor(title, message, closeText = 'Ok') {
        this.title = title;
        this.message = message;
        this.closeText = closeText;

        // set default values
        this.id = undefined;
        this.options = {
            // if click on background hides modal
            backdrop: true,
            // if escape closes the modal
            keyboard: true,
            // shows the modal when initialized
            show: true
        };
        this.showHeaderCloseButton = true;
    }

    addModalToBody() {
        if (this.hasBeenAddedToBody) {
            // we only need one modal with the same id.. what could possibly changed... keep the first one
            return;
        }

        var footer = typeof this.footer === 'undefined' ? '<button type="button" class="btn btn-default" data-dismiss="modal">' + this.closeText + '</button>' : this.footer;
        var components = new Components();
        var dialog = components.createDialogHtml({
            body: this.message,
            footer: footer,
            id: this.id,
            showHeaderCloseButton: this.showHeaderCloseButton,
            title: this.title
        });

        // append it to body, if it not already exists
        if (typeof dialog !== "undefined" && dialog !== null) {
            $('body').append(dialog.html);
        }
    }

    show() {
        if (this.hasBeenAddedToBody === false) {
            this.closeText = typeof this.closeText === 'undefined' ? '' : this.closeText;
            this.id = typeof this.id === 'undefined' ? '' : this.id;
            this.message = typeof this.message === 'undefined' ? '' : this.message;
            this.title = typeof this.title === 'undefined' ? '' : this.title;

            // create id if needed
            if (this.id === '') {
                this.id = utils.getUniqueComponentId({ prefix: 'modal' });
            }
            this.addModalToBody();
        }

        /*
        * Modals do not natively allow several modals to be open at the same time.
        * We have added a z-index fix to solve this issue.
        * To make the z-index fix work we have to call modal show even though the modal may already be visible.
        */
        this.options.show = true;
        $('#' + this.id).modal(this.options);
    }

    hide() {
        if (this.hasBeenAddedToBody) {
            $('#' + this.id).modal('hide');
        }
    }

    static addBackdropZIndexFix() {
        /*
        * Backdrop z-index fix
        * Will make the last shown modal at top of the page
        */
        $(document).on('show.bs.modal', '.modal', function () {
            var zIndex = 1040 + (10 * $('.modal:visible').length);
            $(this).css('z-index', zIndex);
            setTimeout(function () {
                $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
            }, 0);
        });
    }

    static addScrollbarFix() {
        /*
        * Scrollbar fix
        * If several modals are open and you close one, the scrolling will not work on the one in the background.
        * To fix this we follow instructions on: https://stackoverflow.com/questions/19305821/multiple-modals-overlay
        */
        $(document).on('hidden.bs.modal', '.modal', function () {
            $('.modal:visible').length && $(document.body).addClass('modal-open');
        });
    }

    isShown() {
        return $('#' + this.id).hasClass('in');
    }

    get hasBeenAddedToBody() {
        var hasId = typeof this.id !== 'undefined';
        if (hasId) {
            return document.getElementById(this.id) !== null;
        }
        return false;
    }
}
